import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { setToken } from '~entities/studios';

import { useGHLUserContext } from '~entities/users/hooks';
import { setCurrentUser } from '~entities/users/model/user-store';

const RouteComponent = () => {
  const navigate = Route.useNavigate();
  const [isNavigating, setIsNavigating] = useState(false);

  const {
    result,
    error: userContextError,
  } = useGHLUserContext();

  // Handle navigation after decryption is complete
  useEffect(() => {
    // Check if we have decrypted result and haven't navigated yet
    if (result && !isNavigating) {
      const { token, user, activeLocation } = result;

      setToken(token);
      setCurrentUser(user);

      // Set navigating flag before navigation
      setIsNavigating(true);

      // Navigate to ghl-authorize with the locationId from decrypted data
      void navigate({
        to: '/ghl-authorize',
        search: { locationId: activeLocation },
      });
    }
  }, [result, navigate, isNavigating]);

  // Show error if there's any error
  if (userContextError) {
    return (
      <div className='flex h-screen items-center justify-center bg-gray-50 p-4'>
        <div className='max-w-md rounded-lg bg-white p-8 text-center shadow-sm'>
          <div className='mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100'>
            <svg className='h-6 w-6 text-red-600' fill='none' viewBox='0 0 24 24' strokeWidth='1.5' stroke='currentColor'>
              <path strokeLinecap='round' strokeLinejoin='round' d='M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z' />
            </svg>
          </div>
          <h2 className='mb-2 text-lg font-semibold text-gray-900'>
            Unable to Sign In
          </h2>
          <p className='mb-6 text-sm text-gray-600'>
            {userContextError}
          </p>
          <button
            onClick={() => window.location.reload()}
            className='rounded-md bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800'
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute('/exchange-user-context')({
  component: RouteComponent,
});
